import { isIEditorV3 } from "editor-v3";
import { CommentReadDto } from "./interface";

/**
 * Type guard to validate an object is a CommentReadDto.
 *
 * @param obj - Object to check
 * @returns True if the object matches CommentReadDto
 */
export const isCommentReadDto = (obj: unknown): obj is CommentReadDto => {
  return (
    // Check object
    typeof obj === "object" &&
    obj !== null &&
    // Check properties exist
    "id" in obj &&
    "authorId" in obj &&
    "authorDisplayName" in obj &&
    "content" in obj &&
    "createdAt" in obj &&
    "updatedAt" in obj &&
    "updateCount" in obj &&
    // Check properties types
    typeof (obj as CommentReadDto).id === "string" &&
    typeof (obj as CommentReadDto).authorId === "number" &&
    isIEditorV3((obj as CommentReadDto).content) &&
    typeof (obj as CommentReadDto).authorDisplayName === "string" &&
    ((obj as CommentReadDto).parentId === undefined ||
      typeof (obj as CommentReadDto).parentId === "string") &&
    ((obj as CommentReadDto).relatedTo === undefined ||
      typeof (obj as CommentReadDto).relatedTo === "string") &&
    typeof (obj as CommentReadDto).createdAt === "string" &&
    typeof (obj as CommentReadDto).updatedAt === "string" &&
    typeof (obj as CommentReadDto).updateCount === "number" &&
    ((obj as CommentReadDto).entityVersion === undefined ||
      typeof (obj as CommentReadDto).entityVersion === "string")
  );
};
